module.exports = __webpack_public_path__ + "img/icon-living-room.4698cbcd.svg";